// extracted by mini-css-extract-plugin
export default {"section__title":"SectionTitle_section__title__GnLEw"};